var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 50,
    height: 15,
    width: 15,
    className: "loaderColor1",
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1.7s",
    values: "50;5;50;50",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    begin: "0s",
    dur: "1.7s",
    values: "5;27;49;5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 5,
    height: 15,
    width: 15,
    className: "loaderColor2",
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1.7s",
    from: 5,
    to: 5,
    values: "5;50;50;5",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    begin: "0s",
    dur: "1.7s",
    from: 27,
    to: 27,
    values: "27;49;5;27",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 50,
    height: 15,
    width: 15,
    className: "loaderColor3",
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1.7s",
    values: "50;50;5;50",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    from: 49,
    to: 49,
    begin: "0s",
    dur: "1.7s",
    values: "49;5;27;49",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.b2098a43a679d28687f85948062313d9.svg";
export { ForwardRef as ReactComponent };